import React, { FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'

import { SupplierBrandCreateForm } from './createForm'
import { createSupplierBrand, CreateSupplierBrandParams, toastSuccess } from '../../../api'

export const AddSupplierBrandForm = () => {
    const navigate = useNavigate()

    const handleSubmit = (
        e: FormEvent<HTMLFormElement>,
        inputs: CreateSupplierBrandParams
    ) => {
        e.preventDefault()
        createSupplierBrand(inputs)
            .then(json => {
                toastSuccess('Supplier Brand created successfully')
                navigate(`/suppliers/brands/${String(json.data.id)}`)
            })
            .catch(() => {})
    }


    return (
        <div className='container card col-xs-12 col-xl-6'>
            <div className='card-body col-xs-12 row d-flex flex-row justify-content-between mb-5'>
                <div className='row flex-row mb-5'>
                    <h3 className='ps-0 d-inline-flex card-title w-50'>
                        Add Supplier Brand
                    </h3>
                </div>
                <SupplierBrandCreateForm handleSubmit={handleSubmit} />
            </div>
        </div>
    )
}
